import React from 'react'

import { Box } from '@chakra-ui/react'

import genericPlant from 'src/assets/image/generic-plant-2.jpg'
import EmptyState from 'src/components/widgets/EmptyState/EmptyState'
import ItListImage from 'src/components/widgets/ItListImage/ItListImage'

const NoItemsEmptyState: React.FC<{ isPreview: boolean }> = ({ isPreview }) => {
  return (
    <Box px={{ base: 4, lg: isPreview ? 4 : 24 }}>
      <EmptyState
        w="100%"
        title="No items here... for a reason! :)"
        body="This type of content is likely not relevant to the topic of this ItList."
        Image={() => (
          <ItListImage
            htmlWidth={180}
            htmlHeight={180}
            h={180}
            maxW="180px"
            src={genericPlant}
            alt="empty section illustration"
          />
        )}
      />
    </Box>
  )
}

export default NoItemsEmptyState
